import { render, staticRenderFns } from "./NewLeadTypeBtn.vue?vue&type=template&id=6ee6bcf8&scoped=true&"
import script from "./NewLeadTypeBtn.vue?vue&type=script&lang=js&"
export * from "./NewLeadTypeBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee6bcf8",
  null
  
)

export default component.exports